import { SVGProps } from 'react';

const SvgUploadSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M11.646 6.354a.5.5 0 0 0 .708-.708l-4-4a.498.498 0 0 0-.351-.146h-.006a.498.498 0 0 0-.348.144m-.003.003-4 4a.5.5 0 1 0 .708.707L7.5 3.207V11a.5.5 0 0 0 1 0V3.207l3.146 3.147M2 14.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgUploadSmall;
